import React, { useContext } from "react";
import { DataContext } from "../../context/DataContext";
import LoadingSpinner from "./LoadingSpinner";

const LanguageSwitcher = () => {
  const { changeLocale, locale, isLoading } = useContext(DataContext);

  const languages = [
    { code: "en", name: "English", flag: "" },
    { code: "es", name: "Español", flag: "" },
  ];

  const handleLocaleChange = (newLocale: string) => {
    if (newLocale !== locale && !isLoading) {
      changeLocale(newLocale);
    }
  };

  return (
    <div className="language-switcher relative">
      <select
        value={locale}
        onChange={(e) => handleLocaleChange(e.target.value)}
        disabled={isLoading}
        className={`form-select appearance-none text-center transition-opacity duration-200 ${
          isLoading ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`}
        style={{
          backgroundImage: "none",
          paddingRight: "8px",
          textAlignLast: "center",
        }}
        aria-label="Select language"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code} className="text-center">
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
      {isLoading && (
        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2">
          <LoadingSpinner size="sm" message="" className="p-1" />
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
